import {useRunsQueryContext} from '../../../state/runs/hooks';
import * as TableCols from '../../../util/tablecols';

export const useDefaultKeys = () => {
  const {sweep} = useRunsQueryContext();
  if (!sweep) {
    return TableCols.DEFAULT_RUNSELECTOR_KEYS;
  }
  if (sweep.earlyTerminate) {
    return TableCols.DEFAULT_SWEEP_EARLY_TERMINATE_KEYS;
  }
  return TableCols.DEFAULT_SWEEP_KEYS;
};
